<template>
  <div>
    <div v-if="nRequiredErrors" class="px-4 pb-3 error--text">
      You have not provided valid input for {{pl(nRequiredErrors, 'required section')}}.
      <span v-if="count(x => [ 'SUCCESS', 'SUCCESS_MIXED' ].includes(x))">&nbsp;The project will not include <b>any</b> of your inputs.</span>
    </div>
    <div class="px-4 my-n3">
      <div v-for="section in sections" v-if="section.n" class="d-flex align-center my-3">
        <v-icon class="flex-grow-0 mr-2" :color="section.color">{{section.icon}}</v-icon>
        <label class="v-label theme--light">{{section.msg(section.n)}}</label>
      </div>
    </div>
  </div>
</template>


<script>
import { mdiClose, mdiCheckboxBlankOutline, mdiCheckboxMarkedOutline, mdiMinusBoxOutline } from '@mdi/js';


export default {
  name: 'group-video-status',

  props: [ 'status' ],

  data() {
    return { mdiClose };
  },

  computed: {
    sections() {
      return [
        {
          n: this.count(x => x == 'SUCCESS'),
          color: 'success',
          icon: mdiCheckboxMarkedOutline,
          msg: n => `${this.pl(n, 'section')} completed`
        },
        {
          // Strictly for groups
          n: this.count(x => x == 'SUCCESS_MIXED'),
          color: 'success',
          icon: mdiMinusBoxOutline,
          msg: n => `${this.pl(n, 'section')} partially completed`
        },
        {
          n: this.count(x => [ 'ERROR_INVALID', 'WARNING' ].includes(x)),
          color: this.count(x => x == 'ERROR_INVALID') ? 'error' : 'warning',
          icon: mdiMinusBoxOutline,
          msg: n => `${this.pl(n, 'section')} need${n == 1 ? 's' : ''} editing`
        },
        {
          n: this.count(x => x == 'ERROR_MISSING'),
          color: 'error',
          icon: mdiCheckboxBlankOutline,
          msg: n => `${this.pl(n, 'required section')} missing input`
        },
        {
          n: this.count(x => x == 'NONE'),
          color: 'grey lighten-2',
          icon: mdiCheckboxBlankOutline,
          msg: n => `${this.pl(n, 'optional section')} missing input`
        }
      ];
    },

    nRequiredErrors() {
      return this.count(x => [ 'ERROR_INVALID', 'ERROR_MISSING' ].includes(x));
    }
  },

  methods: {
    pl(value, descriptor) {
      return `${value} ${descriptor}${value == 1 ? '' : 's'}`;
    },

    count(pred) {
      return (this.status && this.status.statuses || []).filter(pred).length;
    }
  }
}
</script>
